import { render, staticRenderFns } from "./xy-page-container.vue?vue&type=template&id=3c76c3ea"
import script from "./xy-page-container.vue?vue&type=script&lang=js"
export * from "./xy-page-container.vue?vue&type=script&lang=js"
import style0 from "./xy-page-container.vue?vue&type=style&index=0&id=3c76c3ea&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports